import React from "react";
import { 
	// Box, 
	TextField } from "@mui/material";
import AppCard from "@crema/core/AppCard";
import CalendarWrapper from "./CalendarWrapper";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
// import moment from "moment";

const DateSelector = () => {
	const [value, setValue] = React.useState(new Date());

	return (
		<AppCard sxStyle={{ height: 1 }} contentStyle={{ padding: 0 }}>
			<CalendarWrapper>
				<StaticDatePicker
					orientation="landscape"
					openTo="day"
					value={value}
					onChange={(newValue) => {
						setValue(newValue);
					}}
					renderInput={(params) => <TextField {...params} />}
				/>
			</CalendarWrapper>
		</AppCard>
	);
};

export default DateSelector;
